import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import CallToActionButton from '../../../../../../component/call-to-action-button/call-to-action-button';
import React, { useState } from 'react';
import { addNewDocOperations } from '../operations/add-new-doc-operations';

interface DialogAddNewDocModel {
  closeDialog: () => void;
}
export const DialogAddNewDoc: React.FC<DialogAddNewDocModel> = ({
  closeDialog,
}) => {
  const [docType, setDocType] = useState('');
  const [loading, setLoading] = useState(false);
  const handleOnSubmit = async () => {
    await addNewDocOperations(docType, setLoading, closeDialog);
  };
  return (
    <div>
      <EditText title={'שם סוג המסמך'} onChange={setDocType} />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'אישור'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
